import {
    
    getAllCases,
    deleteCase,
    addCase,
    getAllMajors,
    SubmitCase,
    ReturnCase
} from "@/api/views/caselibrary";

export default {
    name: "ExpData",
    data() {
        return {
            btEdit:false,
            btDelete:false,
            btReturn:false,

            handleSign: "",
            caseName:"",
            caseID:"",
            dialogTitle:"",
            dialogVisible:false,
            caseName:"",
            selectedMajor: null, // 当前选中的专业
            majorOptions: [], // 专业选项列表
            // 列表
            list: {
                // 列表加载状态
                loading: true,
                page: 1,
                size: 10,
                search: "",
                total: 0,
                data: []
            },

        };
    },
    created() {
        this.getDataList();
        this.updateBtState();
    },
    methods: {

        handleSizeChange(size) {
            this.list.size = size;
            this.getDataList();
        },
        handleCurrentChange(current) {
            this.list.page = current;
            this.getDataList();
        },
        getDataList() {
            let params = {};
            params.page = this.list.page;
            params.per_page = this.list.size;
            params.userid= this.$store.state.userInfo.id;
            this.list.loading = true;
            getAllCases(params).then(res => {
                this.list.total = parseInt(res.meta.total);
                this.list.data = res.data;
                this.list.loading = false;
            });
        },
        handleSelectChange(val) {
            self.selectedMajor=val;
         
        },
         /**
        * @name: 删除/修改/添加弹窗
        * @author: camellia
        * @date: 2020-12-29 17:32:19
        */
       handleOpen(sign, title = "", index = "", row = "") {
           const self = this;
           self.handleSign = sign;
           self.dialogTitle = title;
           self.caseID = row.id;
           if (sign == "is_delete") 
           {
               self.dialogVisible = true;
               self.caseName = row.CaseName;
               
           } 
           else if (sign == "is_add") 
           {   this.fetchMajors();
               self.dialogVisible = true;
           }
           else if (sign == "is_update") 
           {
               self.article_id = row.id;
               self.$router.push({
                   path: "/manager/webNewsUpdate",
                   query: {
                       article_id: self.article_id
                   }
               });
           }
       }, 
       // 从后端获取专业列表
       async fetchMajors() {
           try {

            getAllMajors().then(res => {
                const newMajors = res.data;

                this.majorOptions = [];
                newMajors.forEach(major => {
                    this.$set(this.majorOptions, this.majorOptions.length, major);
                });
                // self.majorOptions = res.data;
                // console.log(self.majorOptions);
            });
           } catch (error) {
               console.error('获取专业列表失败', error);
           }
       },
       /**
       * @name: 弹窗确定键点击事件
       * @author: camellia
       * @date: 2021-01-11 10:25:50
       */
      dialogFix() {
          const self = this;
          let data = {
              case_id: self.caseID
          };

          if (self.handleSign == "is_delete") {

            deleteCase(data).then(result => {
 
                  this.$message.success(result.msg);
                  self.dialogVisible = false;
                  self.getDataList()
              }).catch(err => {
                  self.dialogVisible = false;
                  this.$message.error(err);
              });
             
          } else if (self.handleSign == "is_add") {
       
              let data = {

                  caseName: self.caseName,
                   owner:this.$store.state.userInfo.id,
                   major_id: self.selectedMajor

              };
              if (self.caseName == "") {
                  this.$message.error('请填写案例标题');
     
                  return;
              }
 
              addCase(data).then(result => {
                this.$message.success(result.msg);
                self.dialogVisible = false;

                  self.$router.push({
                      path: "/manager/CaseList/CaseEditor",
                      query: {
                        caseID: result.case.id
                      }
                  });

              });

          }
      },handleEdit(row = ""){

        this.$router.push({
            path: "/manager/CaseList/CaseEditor",
            query: {
              caseID: row.id
            }
        },
   
    );

      },handlePreView(row=""){


          // 获取当前域名
      const currentDomain = window.location.origin;
      // 拼接完整 URL
      const fullUrl = `${currentDomain}/#/CaseView?caseID=${row.id}`;

        window.open(fullUrl, '_blank');
      },
      handleSubmit(row=""){
        this.caseID=row.id;
        this.$confirm('是否提交审核？', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '提交',
            cancelButtonText: '取消'
          })
            .then(() => {
                let data = { };
                data.case_id = this.caseID,
                data.userid = this.$store.state.userInfo.id,
               
                SubmitCase(data).then(result => {
                    this.$message.success(result.msg);
                    this.getDataList()

                }).catch(err => {
                    this.$message.error(err);
                });
             
            })
            .catch(action => {
                if (action === 'cancel') {
                    this.$message.info('已取消');
                }
            });
      },  //退回
      handleBack(row =""){
        this.$confirm('是否退回？', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '退回',
            cancelButtonText: '取消'
          })
            .then(() => {
                let data = { };
                data.case_id = row.id,
                data.userid = this.$store.state.userInfo.id,
               
                ReturnCase(data).then(result => {
                    this.$message.success(result.msg);
                    this.getDataList()

                })
            })

      },
      //刷新按钮显示状态
      updateBtState(){
        // btEdit:true,
        // btSubmit:true,
        // btDelete:true,
        // btReturn:true,

        let level = [];
  
        if (JSON.stringify(this.$store.state.userInfo) != "{}") {
        var levelstr=this.$store.state.userInfo.islogin+'';
            level = levelstr.split("");
            console.log(level)
        }
          console.log(level)
        console.log(level[1])
        if(level[1]==2){
            //教师
            this.btEdit=true;
            this.btDelete=true;
        }else if(level[1]==3){
            //学院管理员
            this.btReturn=true;
        }else if(level[1]==4){
            //校级管理员
            this.btReturn=true;
        }else if(level[1]==5){
            //校级管理员
            this.btEdit=true;
            this.btDelete=true;
            this.btReturn=true;
        }

    },issubmitButtonVisible(row= ""){
        let level = [];
  
        if (JSON.stringify(this.$store.state.userInfo) != "{}") {
        var levelstr=this.$store.state.userInfo.islogin+'';
            level = levelstr.split("");

        }
 

        if(level[1]==2){
            //教师
            return {isVisible:row.state==0 , text:'提交学院审核'};
        }else if(level[1]==3){
            //学院管理员

            return {isVisible:true , text:'提交校级审核'};

        }else if(level[1]==4){
            //校级管理员
            return {isVisible:true , text:'上线'};

        }else if(level[1]==5){
            //校级管理员
            if(row.state==9){
                return {isVisible:false , text:'已上线'};
            }
    
            return {isVisible:true , text:'上线'};
        }
    }
    }
}